// extracted by mini-css-extract-plugin
export var addButton = "_5n-d";
export var bullets = "_5n-e";
export var compact = "_5n-2";
export var container = "_5n-j";
export var extendedWarrantyModal = "_5n-f";
export var learn = "_5n-l";
export var learnMore = "_5n-g";
export var offeringOption = "_5n-3";
export var offeringPrice = "_5n-8";
export var offeringSubtitle = "_5n-7";
export var offeringTitle = "_5n-6";
export var offeringsContainer = "_5n-0";
export var pdpTilesBackground = "_5n-n";
export var plan = "_5n-m";
export var regular = "_5n-1";
export var remove = "_5n-k";
export var seeDetailsIcon = "_5n-i";
export var seeDetailsLink = "_5n-h";
export var selectedOption = "_5n-4";
export var shieldIcon = "_5n-b";
export var shieldIconCompact = "_5n-c";
export var subtitle = "_5n-a";
export var title = "_5n-9";
export var unselectedOption = "_5n-5";